import React, { Component, PropTypes } from 'react';

export default class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.searchHelp = this.searchHelp.bind(this);
    const searchStr = props.params ? props.params.searchStr : '';
    this.state = { value: searchStr };
  }

  onChange(e) {
    const value = e.target.value;
    this.setState({ value });
  }

  searchHelp(e) {
    e.preventDefault();
    if (this.state.value) {
      this.props.push(`/help/search/${this.state.value}/`);
    } else {
      this.props.push('/help');
    }
  }

  render() {
    return (<form className="help-search" onSubmit={this.searchHelp}>
      <input
        type="text"
        className="help-search-box"
        placeholder={this.props.placeholder || "Search..."}
        onChange={this.onChange}
        value={this.state.value}
      />
      <button type="submit" className="btn btn-icon-only">
        <i className="fa fa-search"/>
      </button>
    </form>);
  }
}

SearchBox.propTypes = {
  params: PropTypes.shape({
    searchStr: PropTypes.string,
  }).isRequired,
  push: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};



// WEBPACK FOOTER //
// ./help/components/search_box.jsx